function StudentLocationsController($scope, UserService, $state) {}
StudentLocationsController.$inject = ["$scope", "UserService", "$state"];
export default StudentLocationsController;
